import e from"./useProviderAndSigner.js";const n=()=>{const{signer:r}=e();return r?.currentAccount?.address};var d=n;export{d as default};
